/** Short audible alert when a new pending order arrives. */
export function playNewOrderAlert() {
  try {
    const AudioCtx =
      window.AudioContext ||
      (window as unknown as { webkitAudioContext?: typeof AudioContext })
        .webkitAudioContext;
    if (!AudioCtx) return;

    const ctx = new AudioCtx();
    const playBeep = (startAt: number, freq: number) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.value = 0.12;
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(startAt);
      osc.stop(startAt + 0.18);
    };

    playBeep(ctx.currentTime, 880);
    playBeep(ctx.currentTime + 0.22, 988);

    window.setTimeout(() => {
      void ctx.close();
    }, 600);
  } catch {
    /* audio optional */
  }
}
